export default __webpack_public_path__ + "static/product-b-pressstainlesssteel-6b8cab0c042eb9634d0da5dd37ad0688.jpg";